"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_property_decorator_1 = require("vue-property-decorator");
const bmk_ui_framework_1 = require("@biomemakers/bmk_ui_framework");
const SidebarTracking_vue_1 = __importDefault(require("../Layout/SidebarTracking.vue"));
const TopbarTracking_vue_1 = __importDefault(require("../Layout/TopbarTracking.vue"));
const WidgetTrackingGrid_vue_1 = __importDefault(require("./WidgetTrackingGrid.vue"));
const User_1 = __importDefault(require("@common/models/User"));
const trans_1 = require("@common/tsutils/trans");
const SubclientsSwitcher_vue_1 = __importDefault(require("@becrop/components/Common/SubclientsSwitcher.vue"));
const MixpanelHandler_1 = __importDefault(require("@becrop/components/Modules/Common/Models/MixpanelHandler"));
let Dashboard = class Dashboard extends vue_property_decorator_1.Vue {
    constructor() {
        super(...arguments);
        this.vuedata = null;
        this.sidebar_selected = 'home';
        this.user = null;
        this.loading = false;
        this.mixpanelHandler = new MixpanelHandler_1.default();
        this.toastSubclient = false;
        //
        //
        // fetchedWidgets:Widget[] = []
        //
        // async fetchWidgets() {
        //     const baseURL = 'http://localhost:8000'
        //
        //     const config = {
        //         baseURL,
        //         timeout: 30000,
        //         headers: {
        //             'Access-Control-Allow-Origin': '*',
        //             'Access-Control-Allow-Headers': '*',
        //         }
        //     }
        //
        //     axios.create(config);
        //
        //     this.loading = true
        //
        //     const urlKeys = ['pending_gis_file', 'pending_sample_collecting', 'pending_sample_shipping']
        //
        //     let widgetsAll:Widget[] = [{
        //         'title': '',
        //         'subtitle': '',
        //         'entity': '',
        //         'num_pending': -1,
        //         'projects_involved': -1,
        //         'proposals_involved': -1,
        //         'slug': ''
        //     }];
        //
        //     try {
        //         const widgetsP = urlKeys.map(async (k) => {
        //             const url = '/proposals/pending/' + k;
        //             const response = await axios.get(config.baseURL + url);
        //             return response.data[0];
        //         })
        //
        //         widgetsAll = await Promise.all(widgetsP);
        //         this.fetchedWidgets = widgetsAll;
        //
        //     } catch(e:any) {
        //         console.log(e.message);
        //     }
        //
        //     this.loading = false;
        // }
        //
        // mounted() {
        //     this.fetchWidgets();
    }
    get internal_theme() {
        if (this.theme)
            return this.theme;
        return this.$theme.current.value;
    }
    async created() {
        if (this.raw_user)
            this.user = User_1.default.fromJson(this.raw_user);
        const isSunclientChange = localStorage.getItem('is_subclient_change');
        const value = JSON.parse(isSunclientChange);
        if (value === true) {
            this.toastSubclient = true;
            await setTimeout(() => {
                this.toastSubclient = false;
            }, 10000);
            localStorage.setItem('is_subclient_change', JSON.stringify(false));
        }
    }
    is_visible_toast() {
        if (this.toastSubclient)
            return true;
        return false;
    }
    localStorageSubclient(subclientChange) {
        var _a;
        localStorage.setItem('is_subclient_change', JSON.stringify(true));
        localStorage.setItem('subclient_change', JSON.stringify((_a = subclientChange.sub_client) === null || _a === void 0 ? void 0 : _a.nombre_comercial));
    }
    get subclientChange() {
        const isSunclientChange = localStorage.getItem('subclient_change');
        return isSunclientChange;
    }
    get rasterWidgets() {
        return Object.values(this.vuedata.widgets_totals);
    }
    trackInMixpanel(w) {
        this.mixpanelHandler.trackEvent('trackingDashboardWidget', {
            widget: w,
        });
    }
    launchWidget(w) {
        this.trackInMixpanel(w);
        const widgets = ['gis', 'shipping', 'collecting'];
        const wSelected = widgets.find((mywidget) => w.includes(mywidget));
        const myKey = (0, trans_1.trans)('tracking.widget_keys.' + wSelected);
        // let baseURL = 'proposalslist/?status=';
        // baseURL += myKey;
        let baseURL = 'proposalslist';
        window.location.href = '/tracking/' + baseURL;
    }
    loadView(u) {
        switch (u) {
            case 'home':
                this.sidebar_selected = 'home';
                window.location.href = '/tracking/';
                break;
            case 'proposals':
                this.sidebar_selected = 'proposals';
                window.location.href = '/tracking/proposalslist';
                break;
            case 'results':
                this.sidebar_selected = 'results';
                window.location.href = '/dashboard';
                break;
            default:
                this.sidebar_selected = 'home';
                window.location.href = '/tracking/';
                break;
        }
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: String, default: null })
], Dashboard.prototype, "theme", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)()
], Dashboard.prototype, "raw_would_rather_crops", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)()
], Dashboard.prototype, "vuedata", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)()
], Dashboard.prototype, "raw_user", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('toastSubclient')
], Dashboard.prototype, "is_visible_toast", null);
Dashboard = __decorate([
    (0, vue_property_decorator_1.Options)({
        components: {
            StandardTemplate: bmk_ui_framework_1.StandardTemplate,
            SidebarTracking: SidebarTracking_vue_1.default,
            TopbarTracking: TopbarTracking_vue_1.default,
            WidgetTrackingGrid: WidgetTrackingGrid_vue_1.default,
            SubclientsSwitcher: SubclientsSwitcher_vue_1.default,
            Toasts: bmk_ui_framework_1.Toasts,
            CheckRoundedIcon: bmk_ui_framework_1.CheckRoundedIcon,
        },
    })
], Dashboard);
exports.default = Dashboard;
